<template>
  <div>
    <p>余额：222222 LAMB</p>
    <div class="input-wrapper">
      <input class="amount-input">
    </div>
    <div>
      <div>
        <button class="btn">
          授权
        </button>
        <button class="btn disableBtn">
          确认兑换
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  }
};
</script>

<style lang="less" scoped>
p {
  color: #fff;
  font-size: 14px;
}
.input-wrapper {
  width: 50%;
  height: 72px;
  background: #f7f8f9;
  border-radius: 6px;
  border-radius: 15px;
  overflow: hidden;
  .amount-input {
    width: 100%;
    height: 100%;
    outline: none;
    border: none;
    background: #f7f8f9;
    font-size: 40px;
    line-height: 47px;
    color: #14171c;
    padding: 16px;
    caret-color: #0058ff;
  }
  .error-input {
    &:focus {
      border: 1px solid #ff3c00;
      border-radius: 4px;
    }
  }
  .correct-input {
    &:focus {
      border: 1px solid #0058ff;
      border-radius: 4px;
    }
  }
}
.btn {
  width: 10%;
  margin: 40px 20px 30px 0px;
  display: inline-block;
  outline: none;
  background-color: transparent;
  cursor: pointer;
  padding: 10px 20px;
  border: 1px solid #fff;
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  border-radius: 8px;
  &:hover {
    background-color: #fff;
    color: #3a43d8;
  }
}
.disableBtn {
  cursor: not-allowed;
  background: #0058ff;
  border-radius: 4px;
  opacity: 0.3;
}
</style>
